<template>
  <div class="userNews intro-y box overflow-hidden mt-5">
    <el-form label-position="top" :model="form" label-width="100px">
      <el-form-item label="租客姓名">
        {{form.lessee}}
      </el-form-item>
      <template v-if="flag">
        <el-form-item label="身份证号">
          {{form.idNum || "无"}}
        </el-form-item>
        <el-form-item label="手机号">
          {{form.phoneNum || "无"}}
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="身份证号">
          <el-input v-model="form.idNum" placeholder="请输入身份证号" style="width:400px;"/>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="form.phoneNum" placeholder="请输入手机号" style="width:400px;" />
        </el-form-item>
      </template>
      <el-form-item label="备注">
        <el-input v-model="form.contractRemark" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }" style="width:400px;"  />
      </el-form-item>
      <el-form-item v-if="!flag">
        <el-button type="primary" @click='editList'>
          保存
        </el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {getContractDetail,addOrModContract} from '@/api/asset.js'
  import {mapState} from 'vuex'
  export default {
    name: "userNews",
    components: {},
    data() {
      return {
        form: {
          lessee:'',
          idNum: '',
          phoneNum: '',
          contractRemark: '',
        },
        assetId:0,
      }
    },
    methods: {
      getList(){
        let para={assetId:this.assetId}
        getContractDetail(para).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.form = data.content[0]
            this.$store.commit('GET_LESSEE', this.form.lessee)

          } else {
            console.log(err);
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
        })
      },
      editList(){
        addOrModContract(this.form).then(res => {
          let data = res.data
          if (data.code === '000') {
            this.$message.success(data.desc)
            this.getList()
            this.$store.commit('GET_FLAG', true)
          } else {
            this.$message.warning(data.desc)
          }
        }).catch(err => {
          console.log(err);
        }).finally(() => {
        })
      },
    },
    created() {
      if(this.$route.query.contractId){
        this.assetId = this.$route.query.contractId
        this.getList()
      }
    },
    computed:{
      ...mapState({
        flag:state=>state.work.flag
      }),
    }
  }
</script>

<style scoped lang="scss">
  .userNews {
    padding:24px;
  }
</style>
